/* eslint-disable jsx-a11y/no-autofocus */
var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Flex, Text } from 'pcln-design-system';
import Counter from '../Counter';
import { themeGet } from '@styled-system/theme-get';
var StyledFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "TravelerLineItem__StyledFlex",
  componentId: "sc-tq7b0c-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 52px;\n  margin: ", " 0;\n"], ["\n  height: 52px;\n  margin: ", " 0;\n"])), themeGet('space.2'));
function TravelerLineItem(_a) {
  var autoFocus = _a.autoFocus,
    className = _a.className,
    count = _a.count,
    label = _a.label,
    min = _a.min,
    max = _a.max,
    subLabel = _a.subLabel,
    onChange = _a.onChange;
  return React.createElement(React.Fragment, null, React.createElement(StyledFlex, {
    className: className,
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 1
  }, React.createElement(Flex, {
    flexDirection: 'column'
  }, React.createElement(Text, {
    fontSize: 2,
    mr: 1
  }, label), React.createElement(Text, {
    fontSize: 1,
    color: 'text.light'
  }, subLabel)), React.createElement(Counter, {
    autoFocus: autoFocus,
    label: label,
    min: min,
    max: max,
    count: count,
    onChange: onChange
  })));
}
export default TravelerLineItem;
var templateObject_1;